import React from "react"
import styled from "@emotion/styled"
import { Link } from "theme-ui"

const BlueBox = styled(Link)`
    border: 2px solid ${(props) => props.theme.colors.light_blue_1};
    bottom: 3rem;
    height: auto;
    border-radius: 1rem;
    padding: 0.5rem 1rem;
    margin: 1rem;
    flex: 0 0 350px;

    &:hover {
        text-decoration: none !important;
    }

    & p,
    span {
        margin: 0.5rem;
        color: ${(props) => props.theme.colors.text1};
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[5]}) {
        margin: 0.5rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & div {
            flex-direction: column;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & div {
            flex-direction: column;
        }
        margin: 0.3rem;
        padding: 0 0.5rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        flex: 0 0 250px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        flex: 0 0 200px;
    }
`
const HighlightText = styled.span`
    color: ${(props) => props.theme.colors.light_blue_1} !important;
    font-weight: bold;
`

const Cards = ({ issue, date, title, url }) => (
    <BlueBox href={url} target="_blank" rel="noreferrer">
        <HighlightText className="content-paragraph">
            Issue {issue}, {date}
        </HighlightText>
        <p>{title}</p>
    </BlueBox>
)

export default Cards
